/**
 * True for a MARC 21 control field tag (`001`–`009`).
 *
 * Matched on the tag *shape*, which is safe here and only here: this predicate
 * classifies rows that already exist in a stored record, where 00X can only be
 * a real control field. Do NOT reuse it to decide how to *edit* a field — the
 * form asks the EFC's `control_field` flag instead, because the Aleph
 * pseudo-fields (COR, ERR, FMT, R00…) look identical by shape (CZNA-455).
 */
export var isControlFieldTag = function (tag) { return /^00\d$/.test(tag); };
/** The control fields (00X) of a record, in their original order. */
export var extractControlFields = function (fields) { return (fields !== null && fields !== void 0 ? fields : []).filter(function (f) { return isControlFieldTag(f.fieldTag); }); };
/**
 * A display-only control-field row for the MARC preview (CZNA-684).
 *
 * `MarcDataDisplay` reads a control field's data out of `subfields[].value`, so a row
 * built for the preview has to have that shape even though a control field has no
 * subfields of its own. Two kinds of value reach this: a real derived one (`008`), and
 * the "will be assigned on save" text the preview shows in place of an identifier that
 * does not exist yet. Both are display-only — nothing built here is ever saved, because
 * `previewControlFields` never enters react-hook-form state (CZNA-455).
 */
export var controlFieldRow = function (fieldTag, value) { return ({
    fieldTag: fieldTag,
    fieldIndex: 0,
    indicator1: null,
    indicator2: null,
    subfields: [{
            subfieldCode: '',
            subfieldIndex: 0,
            value: value,
            sourceAuthorityId: null,
            sourceHeadingId: null,
            components: [],
        }],
}); };
